module.exports = __webpack_public_path__ + "img/47_4.fde76461.png";